import React from 'react';
import LayoutLandingHeader from '../components/LayoutLandingHeader'; 
import ServicesCard from '../components/ServicesCard'
import LayoutLandingFooter from '../components/LayoutLandingFooter';
import GSTLoader from '../components/GSTLoader'; // Import GSTLoader 

const LayoutLanding = () => {
  return (
    <GSTLoader>
    <>
      <LayoutLandingHeader />
      <br/>
      <ServicesCard />
      <br/>
      <LayoutLandingFooter />
    </>
    </GSTLoader>
  );
};

export default LayoutLanding;
